/* eslint-disable max-len */
export const textArr = [
  '<span>《踏入世界》</span><br>黑暗之中的光点闪烁，<br>失落的羁绊于时空的乱流中<br>拼凑成新世界的记忆。<br><br>“坠落是飞翔的开始。”',
  '<span>《西月之国》</span><br>这世界的神居住在黑暗的地底，<br>深渊下的隐矿蕴藏通向未来的力量，<br>“神向下祀，月自西升”，<br>其名为西月之国。<br><br>',
  '<span>《长梦之坠》</span><br>西月国的巫女从高台上坠落，<br>那羽毛溅落成光，<br>撕裂世界的黑暗秘密。<br><br><br>',
  '<span>《魔渊之战》</span><br>西月112年，魔渊之战以人族的惨胜告终。<br>这是西月历史上的第三次人魔之战。<br>眼前的世界被深渊割裂，是血染成战场。<br>谁知道杀戮之魔，<br>曾经也是破魔之人？',
  '<span>《羁绊之约》</span><br>于长街上回眸，于战场之上并肩，<br>于天地间同游，于时空尽头相守，<br>越过重重世界，紧握着同一双手。<br>记忆在长梦中重塑，新的时空大门已开启。<br>西月国的巫女，请降临这个世界。',

  '<span>《御隐手册》</span><br>一、隐<br>隐，激发于极少数人身上的特殊力量。<br>拥有隐能的人，被称为隐能者。<br>西月国中的隐能者都可以成为御隐师，<br>加入御隐师协会。<br>每年春日祭上，<br>隐能者都需参加巫女主持的赋隐仪式，<br>使隐能平衡，避免魔化。',
  '二、魔<br>隐能者有一定的可能性会魔化。<br>魔大多会失去自我意识，<br>开始无意识地攻击人类。<br>百年前，【魔域】建立于同归之渊的另一端。<br>他们相信，<br>吞噬掉自己的黑暗也许有一天会<br>吞噬掉整个世界。<br>',
  '三、妖<br>近十年才出现在人们视野中的特殊族群。<br>关于妖的记录很少，<br>只有一些传闻中说到妖族外表与常人无异，<br>擅用幻术。<br><br>',
  '四、掠影者<br>掠影者来自掠影阁，是一群神秘的杀手。<br>他们隐于黑暗之中，<br>一旦瞄准了目标，就从未失手过。<br><br>',
  '五、隐石<br>一种特殊的晶石，<br>能激发隐能者的隐能，<br>相传可以储藏外放的隐能能量，<br>是重要的隐能修习材料，<br>为御隐师协会严格管理。<br>据说可以在暗月集买到走私的隐石。<br>',
];
